import {CrudService} from '../../core/common/crud-service';

export interface ZongJiuExportRequest {
    memberIdStart?: string;
    memberIdEnd?: string;
    membershipLevelStart?: string;
    membershipLevelEnd?: string;
    isSuspended?: boolean;
    isWithdrawaled?: boolean;
    delegateMaxCount: number;
    certificationMaxCount: number;
}

class ZongJiuService extends CrudService {
    protected readonly basePath = '/api/report/zongjiu';

    getMemberFile(request: ZongJiuExportRequest): Promise<{blob: Blob; fileName: string}> {
        return this.customPostFile('exportMemberMainFile', request, 'txt', true);
    }

    getProductFile(request: ZongJiuExportRequest): Promise<{blob: Blob; fileName: string}> {
        return this.customPostFile('exportProductMainFile', request, 'txt', true);
    }
}

export const zongJiuService = new ZongJiuService();
